import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import PslLogoNew from "../assets/PslLogoNew.svg";
import {
  tabs,
  features,
  techStack,
  architectureimage,
} from "../utils/loginutils";
import PlaygroundVideo from "../assets/PlaygroundDemoFinal.mp4";

const Login = () => {
  const { instance } = useMsal();
  const [activeTab, setActiveTab] = useState("features");

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "features":
        return (
          <div className="content-grid">
            {features.map((item, idx) => (
              <div key={idx} className="card">
                <h3 className="card-title">{item.title}</h3>
                <p className="card-desc">{item.description}</p>
              </div>
            ))}
          </div>
        );

      case "tech":
        return (
          <div className="content-grid">
            {techStack.map((item, idx) => (
              <div key={idx} className="card">
                <h3 className="card-title">{item?.title}</h3>
                <p className="card-desc">{item?.description}</p>
              </div>
            ))}
          </div>
        );

      case "architecture":
        return (
          <div className="architecture-container">
            {architectureimage.map((img, i) => (
              <img
                key={i}
                src={img.src}
                alt={img.altl ?? `Architecture ${i + 1}`}
                loading="lazy"
                className="architecture-img"
              />
            ))}
          </div>
        );

      case "demo":
        return (
          <div className="demo-wrapper">
            <video
              className="demo-video"
              controls
              preload="metadata"
              autoPlay
              muted
              loop
              playsInline
            >
              <source
                src="https://persistentsystems.sharepoint.com/sites/GenAIHubMarketplace/_layouts/15/download.aspx?UniqueId=dd8a7f25-ad80-4f42-9876-58726a574ae7&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create"
                type="video/mp4"
              />
            </video>
          </div>
        );

      default:
        return <p className="text-white px-4">Content coming soon...</p>;
    }
  };

  return (
    <div className="page-root">
      {/* Background video */}
      <video
        autoPlay
        loop
        preload="auto"
        muted
        playsInline
        className="bg-video"
      >
        <source src="GenAiHubLoginVideo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Gradient overlay */}
      <div className="bg-overlay" />

      {/* Decorative grid lines */}
      <div className="decor-grid">
        <div className="decor-line decor-line-v center-50" />
        <div className="decor-line decor-line-v left-90" />
        <div className="decor-line decor-line-h top-12" />
        <div className="decor-line decor-line-h top-70" />
      </div>

      {/* Header / Hero */}
      <div className="hero">
        <div className="hero-brand">
          <img src={PslLogoNew} alt="Persistent Logo" className="brand-logo" />
        </div>

        <div>
          <h1 className="hero-title">
            <span className="accent">Playground</span>
          </h1>
          <p className="hero-subtitle">
            A self-service environment for running GenAI experiments using Large
            Language Models (LLMs) on enterprise data. Single interface to
            multiple LLMs (Azure OpenAI, AWS Bedrock, Google Gemini, LLaMA2 etc)
            for quick experimentation. Start a new chat, resume old threads, or
            dive into advanced features—all from one place.
          </p>
          <button
            onClick={handleLogin}
            className="btn-signin"
            aria-label="Sign In"
            type="button"
          >
            Sign In
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs-area">
        <nav className="tabs">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.value;
            return (
              <button
                key={tab.value}
                type="button"
                onClick={() => setActiveTab(tab.value)}
                className={`tab-btn ${isActive ? "is-active" : ""}`}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Content */}
      <div className="content-area">{renderContent()}</div>
    </div>
  );
};

export default Login;
